import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let csrfToken = null;

export async function ensureCsrf() {
  if (!csrfToken) {
    const { data } = await axios.get(`${API}/auth/csrf`, { withCredentials: true });
    csrfToken = data.csrf_token;
  }
  return csrfToken;
}

const PREVIEW_ALLOWED = ["/auth/logout", "/notifications/seen"];

api.interceptors.request.use(async (config) => {
  if (["post", "put", "patch", "delete"].includes(config.method)) {
    if (sessionStorage.getItem("fcg-view-as") && !PREVIEW_ALLOWED.includes(config.url)) {
      const err = new Error("preview");
      err.response = { status: 403, data: { detail: "This is a read-only preview. Leave the preview to make changes." } };
      throw err;
    }
    config.headers["X-CSRF-Token"] = await ensureCsrf();
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !url.startsWith("/auth/")) {
      window.dispatchEvent(new Event("fcg:unauthorised"));
    }
    return Promise.reject(error);
  }
);

export function errorMessage(e, fallback = "Something went wrong. Try again in a moment.") {
  if (!e?.response) return "We could not reach the hub. Check your connection and try again.";
  const detail = e.response.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const field = Array.isArray(d.loc) ? d.loc[d.loc.length - 1] : "";
        const msg = (d.msg || "").replace(/^Value error, /, "");
        return field && field !== "body" ? `${String(field).replace(/_/g, " ")}: ${msg}` : msg;
      })
      .join(" ");
  }
  return detail.msg || fallback;
}

export async function downloadFile(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const match = cd.match(/filename="([^"]+)"/);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : fallbackName;
  a.click();
  URL.revokeObjectURL(url);
}
